<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #search-account="{ query }">
        <el-input
          v-model="query.accountValue"
          :placeholder="query.accountType === 'uid' ? '输入代理ID' : '输入代理账号'"
          :inputmode="query.accountType === 'uid' ? 'numeric' : 'text'"
          maxlength="20"
          clearable
          @input="onAccountInput(query, $event)"
        >
          <template #prepend>
            <el-select v-model="query.accountType" style="width: 100px" @change="onAccountTypeChange(query, $event)">
              <el-option label="代理账号" value="username"></el-option>
              <el-option label="代理ID" value="uid"></el-option>
            </el-select>
          </template>
        </el-input>
      </template>

      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleAdd">新增代理</el-button>
          <el-button type="primary" size="mini" @click="handleAgentModeSetting">普通代理设置</el-button>
          <el-button type="primary" size="mini" @click="handleOfficialAgentModeSetting">官方代理设置</el-button>
        </div>
      </template>

      <template #colUsername="{ row }">
        <MemberAccountCell
          :key="row.uid"
          :row="row"
          :vip-level="row.agent_level"
          :username="row.username"
          :uid="row.uid"
          tag-prefix="LV"
          :tag-type="row.agent_status === 2 ? 'warning' : 'info'"
        />
      </template>
      <template #colAgentStatus="{ row }">
        {{ row.agent_status | formatAgentStatus }}
      </template>
      <template #colInviterUsername="{ row }">
        <span v-if="!row.inviter_uid">--</span>
        <MemberAccountCell
          v-else
          :key="row.inviter_uid"
          :row="{
            uid: row.inviter_uid,
            username: row.inviter_username,
          }"
          :username="row.inviter_username"
          :uid="row.inviter_uid"
        />
      </template>
      <template #colShareNum="{ row }">
        <span v-if="!row.share_num">--</span>
        <el-button v-else type="text" size="small" @click="handleViewAgents(row)">{{ row.share_num }}</el-button>
      </template>
      <template #colShareTwoNum="{ row }">
        <span v-if="!row.share_two_num">--</span>
        <el-button v-else type="text" size="small" @click="handleViewIndirectAgents(row)">{{
          row.share_two_num
        }}</el-button>
      </template>
      <template #colBackGold="{ row }">
        {{ row.agent_back_gold | centsToYuan }}
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handlePreview(row)">查看</el-button>
        <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
      </template>
    </SchemaTablePage>
    <el-dialog
      class="page-dialog center-dialog"
      :visible="addDialogVisible"
      :title="isEdit ? '编辑代理' : isPreview ? '查看代理' : '新增代理'"
      width="600px"
      @close="addDialogVisible = false"
    >
      <el-form ref="addFormRef" class="add-level-form" :model="addAgentForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="代理账号" prop="username">
          <el-input
            v-model="addAgentForm.username"
            :disabled="isPreview || isEdit"
            type="textarea"
            :rows="isPreview || isEdit ? 1 : 6"
            placeholder="请输入代理账号，每行一个"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理类型" prop="agent_status">
          <el-radio-group v-model="addAgentForm.agent_status" :disabled="isPreview">
            <el-radio :label="1" :value="1">普通代理</el-radio>
            <el-radio :label="2" :value="2">官方代理</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          v-if="addAgentForm.agent_status === 1 || addAgentForm.agent_status === 2"
          style="
            margin: 0px 0 22px 100px;
            width: 400px;
            background-color: #f4f4f5;
            color: #909399;
            padding: 10px;
            border-radius: 5px;
          "
        >
          <ul v-if="addAgentForm.agent_status === 1" style="list-style: none; padding: 0; margin: 0">
            <li>代理计算层级：{{ agentModeSetting?.level_count | formatLevelCount }}</li>
            <li>直接下级返佣比例：{{ agentModeSetting?.share_one_rate }}%</li>
            <li>二级代理返佣比例：{{ agentModeSetting?.share_two_rate }}%</li>
          </ul>
          <ul v-else style="list-style: none; padding: 0; margin: 0">
            <li>代理名称：{{ currentAgentLevel?.level_name }}</li>
            <li>新增直属下级(人数)：{{ currentAgentLevel?.need_share_num | formatShareNum }}</li>
            <li>晋级条件(需再获得佣金)：≥{{ currentAgentLevel?.upgrade_need_gold | formatGold }}</li>
            <li>直属代理佣金比例：{{ currentAgentLevel?.share_one_rate }}%</li>
            <li>二级代理佣金比例：{{ currentAgentLevel?.share_two_rate }}%</li>
          </ul>
        </div>
        <el-form-item v-if="addAgentForm.agent_status === 2" label="代理等级" prop="agent_level">
          <el-select v-model="addAgentForm.agent_level" placeholder="请选择" :disabled="isPreview">
            <el-option
              v-for="item in agentLevelList"
              :key="item.agent_level"
              :label="`LV${item.agent_level}`"
              :value="item.agent_level"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isPreview && !isEdit" label="代理密码" prop="password">
          <el-input v-model="addAgentForm.password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="代理备注" prop="agent_remark">
          <el-input v-model="addAgentForm.agent_remark" :disabled="isPreview" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 代理数量列表弹窗 -->
    <AgentCountListDialog
      :visible.sync="agentCountListDialogVisible"
      :level="agent_level"
      @closed="handleAgentCountListClosed"
    />

    <!-- 代理模式设置弹窗 -->
    <AgentModeSettingDialog :visible.sync="agentModeSettingDialogVisible" @closed="handleAgentModeSettingClosed" />

    <!-- 直属下级用户列表弹窗 -->
    <AgentInviteUserListDialog
      :visible.sync="agentInviteUserListDialogVisible"
      :inviter-uid="agent_uid"
      :username="agent_username"
      @closed="handleAgentInviteUserListClosed"
      :type="agent_type"
    />

    <!-- 官方代理设置弹窗 -->
    <el-dialog
      class="page-dialog center-dialog official-agent-level-dialog"
      title="官方代理设置"
      :visible.sync="officialAgentLevelDialogVisible"
      width="1200px"
    >
      <AgentLevel v-if="officialAgentLevelDialogVisible" :dialog-mode="true" />
    </el-dialog>
  </div>
</template>

<script>
import { AgentApi } from '@/api/agent'
import { centsToYuan } from '@/utils/amount'
import lineReader from '@/utils/line-reader'
import AgentCountListDialog from './components/agent-count-list.dialog.vue'
import AgentInviteUserListDialog from './components/agent-invite-user-list.dialog.vue'
import AgentModeSettingDialog from './components/agent-mode-setting.dialog.vue'
import AgentLevel from './agent-level.vue'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'AgentList',
  components: {
    AgentCountListDialog,
    AgentInviteUserListDialog,
    AgentLevel,
    AgentModeSettingDialog,
    MemberAccountCell,
    SchemaTablePage,
  },
  filters: {
    centsToYuan,
    formatLevelCount(value) {
      if (value == null) {
        return '--'
      }
      if (value === 2) {
        return '二级'
      } else if (value === 3) {
        return '三级'
      }
      return '--'
    },
    formatAgentStatus(value) {
      if (value === 1) {
        return '普通代理'
      } else if (value === 2) {
        return '官方代理'
      }
      return '--'
    },
    formatShareNum(value) {
      if (value == null) {
        return '--'
      }

      return `≥${value}`
    },
    formatGold(value) {
      if (value == null) {
        return '--'
      }

      return value.toFixed(2)
    },
  },
  data() {
    return {
      defaultQuery: {
        // 筛选用空字符串表示「全部」，避免 el-select 使用 null 时选中项不回显
        agent_level: '',
        agent_status: '',
        range_time: [],
        accountType: 'username',
        accountValue: '',
        inviter_username: '',
      },
      searchSchema: [],
      tableColumns: [
        { type: 'index', label: '序号', width: 60, align: 'center', resizable: false },
        { prop: 'username', label: '代理账号', minWidth: 140, align: 'center', resizable: false, slot: 'colUsername' },
        {
          prop: 'agent_status',
          label: '代理类型',
          minWidth: 100,
          align: 'center',
          resizable: false,
          slot: 'colAgentStatus',
        },
        {
          prop: 'inviter_username',
          label: '上级代理',
          minWidth: 140,
          align: 'center',
          resizable: false,
          slot: 'colInviterUsername',
        },
        {
          prop: 'share_num',
          label: '直属代理(人数)',
          minWidth: 120,
          align: 'center',
          resizable: false,
          slot: 'colShareNum',
        },
        {
          prop: 'share_two_num',
          label: '二级代理(人数)',
          minWidth: 120,
          align: 'center',
          resizable: false,
          slot: 'colShareTwoNum',
        },
        {
          prop: 'agent_back_gold',
          label: '累计获得佣金',
          minWidth: 120,
          align: 'center',
          resizable: false,
          slot: 'colBackGold',
        },
        {
          fixed: 'right',
          prop: 'action',
          label: '操作',
          width: 120,
          align: 'center',
          resizable: false,
          slot: 'colActions',
        },
      ],
      agentLevelList: [],

      addDialogVisible: false,
      isEdit: false,
      isPreview: false,
      editId: null,
      addAgentForm: {
        agent_level: null,
        agent_remark: '',
        agent_status: null,
        username: '',
        password: null,
      },
      addFormRules: {
        username: [
          { required: true, message: '请输入代理账号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const lines = lineReader(value)
              if (lines.length === 0) {
                callback(new Error('请输入代理账号'))
              }
              callback()
            },
          },
        ],
        agent_status: [{ required: true, message: '请选择代理类型', trigger: 'blur' }],
        agent_level: [{ required: true, message: '请选择代理等级', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入代理密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              // 密码为6-12位数字字母组合，不允许特殊符号
              const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/
              if (!value) {
                callback()
              } else if (!reg.test(value)) {
                callback(new Error('密码需为6-12位数字字母组合'))
              } else {
                callback()
              }
            },
          },
        ],
      },

      // 代理数量列表弹窗
      agentCountListDialogVisible: false,
      agent_level: null,

      // 直属下级用户列表弹窗
      agentInviteUserListDialogVisible: false,
      agent_uid: null,
      agent_username: '',
      agent_type: 'direct', // direct: 直属代理, indirect: 二级代理
      // 代理模式设置弹窗
      agentModeSettingDialogVisible: false,
      officialAgentLevelDialogVisible: false,

      // 代理模式设置
      agentModeSetting: {},
    }
  },
  computed: {
    currentAgentLevel() {
      return this.agentLevelList.find(item => item.agent_level === this.addAgentForm.agent_level)
    },
  },
  watch: {
    agentLevelList: {
      handler() {
        this.buildSearchSchema()
      },
      immediate: true,
    },
  },
  mounted() {
    this.getAgentLevelList()
  },
  methods: {
    onAccountTypeChange(query, type) {
      if (type === 'uid') {
        //去掉非数字字符
        query.accountValue = query.accountValue.replace(/\D/g, '')
      }
    },
    buildSearchSchema() {
      const levelOpts = [
        { key: 'lv_all', label: '全部', value: '' },
        ...this.agentLevelList.map(item => ({
          key: `lv_${item.agent_level}`,
          label: `LV${item.agent_level}`,
          value: item.agent_level,
        })),
      ]
      this.searchSchema = [
        {
          prop: 'account',
          label: '代理账号/ID',
          component: 'slot',
          slot: 'search-account',
        },
        {
          prop: 'agent_level',
          label: '代理等级',
          component: 'select',
          componentProps: { clearable: true },
          options: levelOpts,
        },
        {
          prop: 'agent_status',
          label: '代理类型',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { key: 'as_all', label: '全部', value: '' },
            { key: 'as_1', label: '普通代理', value: 1 },
            { key: 'as_2', label: '官方代理', value: 2 },
          ],
        },
        {
          prop: 'inviter_username',
          label: '上级代理',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'range_time',
          label: '统计时间',
          component: 'datetime-range',
          componentProps: {
            placeholder: '请选择统计时间范围',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          },
          span: { xs: 24, sm: 24, md: 12, lg: 12 },
        },
        { component: 'actions' },
      ]
    },
    request(params) {
      return AgentApi.getAgentList(params)
    },
    buildParams({ query, page, limit }) {
      const handleTime = date => {
        if (!date) return
        const d = date instanceof Date ? date : new Date(date)
        return Math.floor(d.getTime() / 1000)
      }
      const empty = v => v === '' || v == null
      const params = {
        agent_level: empty(query.agent_level) ? void 0 : query.agent_level,
        agent_status: empty(query.agent_status) ? void 0 : query.agent_status,
        inviter_username: query.inviter_username || void 0,
        start_at: handleTime(query.range_time?.[0]) || void 0,
        end_at: handleTime(query.range_time?.[1]) || void 0,
        page,
        page_size: limit,
      }
      // 根据 accountType 设置 uid 或 username
      if (query.accountType === 'uid') {
        params.uid = query.accountValue || void 0
      } else {
        params.username = query.accountValue || void 0
      }
      return params
    },
    parseResult(res) {
      return {
        list: res?.data?.list || [],
        total: res?.data?.total || 0,
      }
    },
    reloadTable() {
      this.$refs.tablePageRef?.reload?.()
    },
    onAccountInput(query, value) {
      if (query.accountType === 'uid') {
        query.accountValue = String(value ?? '').replace(/\D+/g, '')
      }
    },
    async getAgentLevelList() {
      const res = await AgentApi.getAgentLevelList()
      if (res.code === 0) {
        this.agentLevelList = res.data.list || []
      }
    },
    getAgentList() {
      this.reloadTable()
    },

    handleViewAgents(data) {
      this.agent_type = 'direct'
      this.agent_uid = data.uid
      this.agent_username = data.username
      this.agentInviteUserListDialogVisible = true
    },

    handleViewIndirectAgents(data) {
      this.agent_type = 'indirect'
      this.agent_uid = data.uid
      this.agent_username = data.username
      this.agentInviteUserListDialogVisible = true
    },

    async getAgentModeSetting() {
      const res = await AgentApi.getAgentModeSetting()
      if (res.code === 0) {
        this.agentModeSetting = res.data
      }
    },

    async handleAdd() {
      const res = await AgentApi.getAgentModeSetting()
      if (res?.data.back_model_type <= 0) {
        this.$message.warning('代理模式未设置,请先设置代理模式')
        return
      }
      this.addAgentForm = {
        agent_level: 1,
      }
      this.addDialogVisible = true
      this.isEdit = false
      this.isPreview = false
      this.editId = null

      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate()
      })
    },
    async addAgent(data) {
      const res = await AgentApi.addAgent(data)
      if (res.code === 0) {
        const successNumber = res.data.success_num
        if (successNumber > 0) {
          this.$message.success(`成功新增${successNumber}个代理`)
          this.addDialogVisible = false

          this.$refs.addFormRef.resetFields()
          this.addAgentForm = {
            agent_level: 1,
          }

          this.getAgentList()
        } else {
          const err = res?.data?.error_str[0] || '新增失败'
          this.$message.error(err)
        }
      }
    },
    async editAgent(data) {
      const res = await AgentApi.editAgent(data)
      if (res.code === 0) {
        this.$message.success('编辑成功')
        this.addDialogVisible = false
        this.getAgentList()
      }
    },
    handleAddSubmit() {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) {
          return
        }
        const params = {
          agent_status: this.addAgentForm.agent_status,
          username: lineReader(this.addAgentForm.username),
          password: this.isEdit ? void 0 : this.addAgentForm.password,
          agent_remark: this.addAgentForm.agent_remark,
        }

        if (this.addAgentForm.agent_status === 2) {
          params.agent_level = this.addAgentForm.agent_level
          params.level_name = this.currentAgentLevel.level_name
        }

        if (this.isEdit) {
          this.editAgent({ ...params, uid: this.editId })
        } else {
          this.addAgent({ ...params })
        }
      })
    },
    handleEdit(data) {
      this.getAgentModeSetting()
      this.addAgentForm = {
        agent_level: data.agent_level,
        agent_remark: data.agent_remark,
        agent_status: data.agent_status,
        username: data.username,
        password: null,
      }
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
      this.addDialogVisible = true
      this.isEdit = true
      this.isPreview = false
      this.editId = data.uid
    },
    handlePreview(data) {
      this.getAgentModeSetting()
      this.addAgentForm = {
        agent_level: data.agent_level,
        agent_remark: data.agent_remark,
        agent_status: data.agent_status,
        username: data.username,
        password: null,
      }
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields()
      this.addDialogVisible = true
      this.isPreview = true
      this.isEdit = false
      this.editId = data.uid
    },
    handleAgentInviteUserListClosed() {
      this.agent_uid = null
      this.agent_username = ''
      this.agentInviteUserListDialogVisible = false
    },
    handleAgentCountListClosed() {
      this.agent_level = null
    },
    handleAgentModeSetting() {
      this.agentModeSettingDialogVisible = true
    },
    handleOfficialAgentModeSetting() {
      this.officialAgentLevelDialogVisible = true
    },
    handleAgentModeSettingClosed() {
      this.agentModeSettingDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.label-text {
  line-height: 1.5;
  font-weight: 600;
  text-align: right;
}
.label-text-sub {
  line-height: 1;
  text-align: right;
}
.label-container {
  display: inline-block;
}

.add-level-form {
  ::v-deep {
    .el-input-number .el-input__inner {
      text-align: left;
    }
  }
}

.rate-item {
  position: relative;
}

.suffix {
  position: absolute;
  left: 388px;
  top: 50%;
  transform: translateY(-50%);
}

.official-agent-level-dialog {
  ::v-deep {
    .el-dialog__body {
      padding: 12px;
      height: 70vh;
      overflow: auto;
    }
  }
}
</style>
